export default __webpack_public_path__ + "static/media/6-mountains-right.9e61c66f.png";